<template>
  <print v-if="isPrint" :form="form" :board="board" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <!--  [신규] SHM 시스템 URL 생성 및 메뉴 구성 | #86ep5bb9n 요청에 의해 메뉴 숨김 -->
    <!--    <table-equipment-->
    <!--      class="mt-5"-->
    <!--      :list="form.equipmentList"-->
    <!--      @updateList="updateList"-->
    <!--      :isPrint="isPrint"-->
    <!--      :isReadonly="board.readonly"-->
    <!--    ></table-equipment>-->

    <!--    점검대상-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 점검대상-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->

    <!--    <div class="gap-x-6 gap-y-4 mt-4">-->
    <!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
    <!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
    <!--        <vs-checkbox-->
    <!--          class="mr-1 mb-2"-->
    <!--          :readonly="board.readonly">-->
    <!--          {{form.inspectionTitle}}-->
    <!--        </vs-checkbox>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    지게차-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle + ' 작업'"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!-- 결재란 -->
    <div class="mt-8">
      <div>
        <h5><i class="dot"></i> 결재란</h5>
      </div>
      <name-with-signature-row label-name="작성자" :name.sync="form.sign1.name" :signature.sync="form.sign1.sign" />
      <name-with-signature-row label-name="검토자" :name.sync="form.sign2.name" :signature.sync="form.sign2.sign" />
      <name-with-signature-row label-name="회람자" :name.sync="form.sign3.name" :signature.sync="form.sign3.sign" />
      <name-with-signature-row label-name="승인자" :name.sync="form.sign4.name" :signature.sync="form.sign4.sign" />
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import NameWithSignatureRow from "@/components/NameWithSignatureRow.vue";
import Print from "@/views/boards/single-page/214/Print.vue";

export default {
  components: {
    Print,
    NameWithSignatureRow,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        this.form.inspectionTitle = this.inspectionTitle;
        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = value.inputA_2;
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "지게차",
      form: {
        inspectionTitle: "지게차",
        stdInfo: {},
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },
        sign4: {
          name: "",
          sign: "",
        },
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label:
            "전조등, 후미등, 방향지시기 및 후진경보장치, 경광등의 정상작동여부를 정기적으로 점검한다.",
          is_checked: "",
        },
        {
          id: 2,
          label: "백레스트 및 헤드가드가 파손되지 않았다.",
          is_checked: "",
        },
        {
          id: 3,
          label:
            "지게차 운전원의 자격을 확인하고, 지정된 자가 운전하도록 관리한다.",
          is_checked: "",
        },
        {
          id: 4,
          label:
            "지게차 운전원에게 작업방법, 작업 순서, 운행 경로 등에 관한 내용을 교육한다.",
          is_checked: "",
        },
        {
          id: 5,
          label: "지게차 운전시 운전원이 안전벨트를 착용하도록 한다.",
          is_checked: "",
        },
        {
          id: 6,
          label:
            "지게차에 화물을 적재할 경우에는 운전원의 시야를 가리지 않도록 한다.",
          is_checked: "",
        },
        {
          id: 7,
          label: "지게차 작업 반경 내에 다른 작업자가 이동하지 않도록 한다.",
          is_checked: "",
        },
        {
          id: 8,
          label: "작업장을 이동할 때 제한속도를 지정하였다.",
          is_checked: "",
        },
        {
          id: 9,
          label:
            "후진, 회전 등 장비 이동 시에 근로자 충돌방지를 위한 후진경보기와 경광등 혹은 후방감지기를 갖추었다. ",
          is_checked: "",
        },
        {
          id: 10,
          label: "지게차 허용하중을 초과하여 적재하지 않는다.",
          is_checked: "",
        },
        {
          id: 11,
          label: "지게차 운행중에 적재한 화물이 떨어지지 않도록 고정한다.",
          is_checked: "",
        },
        {
          id: 12,
          label:
            "하역운반 작업장 바닥은 평탄하고 견고한 곳으로 별도로 지정한다.",
          is_checked: "",
        },
        {
          id: 13,
          label: "지게차 작업장 이동경로에 적재물을 방치하지 않는다.",
          is_checked: "",
        },
        {
          id: 14,
          label: "작업 종료 후 지게차 열쇠는 별도 관리하고 있다.",
          is_checked: "",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
